import { ModalBase } from "../../../../components/Modals/ModalBase"
import InputForm from "../InputFormV2"

export default function ModalDescuentoNCE (props: any) {
    const {formProducto, onChangeFormDescuento, onClickCerrar, onClickAgregar, errors} = props

    return (
        <ModalBase Styles={{minWidth: "40%"}}>
            <div className="cf-modal-container">
                <div><h3 className="card-title">Descuento</h3></div>
                <div className="cf-row-inputs" style={{marginTop:"2%"}}>
                    <InputForm
                        disabled = {props.notaRemision} 
                        maxLength = {100}
                        type = 'text'
                        value = {formProducto.descripcion}
                        name = 'descripcion'
                        onChange = {(e: any) => onChangeFormDescuento(e.target.name, e.target.value)}
                        placeholder = 'Descripción'
                        required
                        label = 'Descripción'
                        error = {errors.descripcion}
                    />
                </div>
                <div className="cf-row-inputs" style={{marginTop:"2%"}}>
                    <InputForm 
                        disabled = {props.notaRemision}
                        maxLength = {15}
                        type = 'text'
                        value = {formProducto.precio}
                        name = 'precio'
                        onChange = {(e: any) => onChangeFormDescuento(e.target.name, e.target.value)}
                        placeholder = 'Precio'
                        required
                        label = 'Precio'
                        error = {errors.precio}
                    />
                </div>
                <div className="cf-calculos-producto" style={{marginTop:"3%"}}>
                    <div className="w-layout-hflex button-actions">
                        <button className="button transparent" onClick={onClickCerrar}>Cancelar</button>
                        <button className="button" onClick={onClickAgregar}>Agregar</button>
                    </div>
                </div>
            </div>
        </ModalBase>
    )
}